import classNames from 'classnames'
import * as React from 'react'
import {Link} from 'react-router-dom'

import styles from './SidebarLink.css'

type ActiveLinkProps = React.ComponentProps<typeof Link> & {
  tailClassName?: string
  tail?: React.ReactNode
}

type InctiveLinkProps = React.HTMLAttributes<HTMLDivElement> & {
  tailClassName?: string
  tail?: React.ReactNode
}

function LinkContent({children, tail, tailClassName}: InctiveLinkProps) {
  return (
    <>
      <div className={styles.content}>{children}</div>
      {tail != null ? (
        <div className={classNames(styles.tail, tailClassName)} data-test-sidebar-link={'tail'}>
          {tail}
        </div>
      ) : null}
    </>
  )
}

export default function SidebarLink({
  children,
  tail,
  className,
  tailClassName,
  ...htmlProps
}: ActiveLinkProps) {
  return (
    <Link
      className={classNames(styles.link, styles.activeLink, className)}
      data-test-sidebar-link={'base'}
      {...htmlProps}
    >
      <LinkContent tail={tail} tailClassName={tailClassName}>
        {children}
      </LinkContent>
    </Link>
  )
}

export function InactiveSidebarLink({children, tail, className, ...htmlProps}: InctiveLinkProps) {
  return (
    <div
      className={classNames(styles.link, className)}
      data-test-sidebar-link={'base'}
      {...htmlProps}
    >
      <LinkContent tail={tail}>{children}</LinkContent>
    </div>
  )
}
